
import { UserOrg } from "@/types/subscription";
import { supabase } from "@/lib/supabase";

/**
 * Récupère les organisations d'un utilisateur
 */
export async function fetchUserOrganizations(userId: string): Promise<UserOrg[]> {
  try {
    const { data, error } = await supabase
      .from('organization_members')
      .select(`
        organization:organizations (
          id,
          name,
          plan,
          owner_id,
          subscription_plan_id,
          is_yearly_billing
        )
      `)
      .eq('user_id', userId)
      .eq('status', 'active');
      
    if (error) {
      console.error('Erreur lors de la récupération des organisations:', error);
      throw new Error('Impossible de récupérer vos organisations');
    }
    
    if (!data || data.length === 0) {
      return [];
    }
    
    // Transformer les données brutes en objets UserOrg
    return data.map((item: any) => {
      const org = item.organization;
      return {
        id: org?.id || '',
        name: org?.name || '',
        plan: org?.plan || '',
        owner_id: org?.owner_id || '',
        subscription_plan_id: org?.subscription_plan_id || '',
        is_yearly_billing: org?.is_yearly_billing || false,
      };
    }).filter((org: UserOrg) => org.id !== ''); // Filtrer les organisations null
  } catch (error) {
    console.error('Exception lors de la récupération des organisations:', error);
    throw error;
  }
}

/**
 * Met à jour le plan d'abonnement d'une organisation
 */
export async function updateOrganizationPlan(
  organizationId: string,
  userId: string,
  planId: string,
  isYearly: boolean
): Promise<void> {
  try {
    // Initialement, nous faisons juste une mise à jour directe dans la base
    // Dans une implémentation complète, cela déclencherait le processus de paiement
    const { error } = await supabase
      .from('organizations')
      .update({
        subscription_plan_id: planId,
        is_yearly_billing: isYearly,
      })
      .eq('id', organizationId);
      
    if (error) {
      console.error('Erreur lors de la mise à jour du plan:', error);
      throw new Error('Impossible de mettre à jour le plan d\'abonnement');
    }
  } catch (error) {
    console.error('Exception lors de la mise à jour du plan:', error);
    throw error;
  }
}
